import './CoralQuoteCards.scss'

import { CoralCardsSlider } from '@websrc/App/Components/CoralCardsSlider/CoralCardsSlider'
import { CoralHeading } from '@websrc/App/Components/CoralHeading/CoralHeading'
import { CoralQuoteLarge } from '@websrc/App/Components/CoralQuoteLarge/CoralQuoteLarge'
import { mapCoralWebQuoteCards } from '@websrc/DataMappers/mapSpot'
import React, { FC } from 'react'

type CoralQuoteCardsProps = ReturnType<typeof mapCoralWebQuoteCards>

export const CoralQuoteCards: FC<CoralQuoteCardsProps> = (props) => {
  return (
    <div className={'category-coral-spot'}>
      <CoralHeading header={props.header} />
      <CoralCardsSlider forceRow={true} fullExpand={true}>
        {props.quotes.map((quote, index) => (
          <CoralQuoteLarge key={index} {...quote} />
        ))}
      </CoralCardsSlider>
    </div>
  )
}
